
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// MUI
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

// DATA
import { frequencyAliasFromRecurrence, frequencyAliases, recurrenceFromFrequencyAlias,
  frequencyAliasTypes } from 'data/scheduledTransactions/scheduledTransactionsUtils';


const useStyles = makeStyles((theme) => ({
  root: {
    height: 23,
    borderRadius: 3,
  },
  input: {
    ...theme.typography.caption,
    background: 'none',
    width: 'fit-content',
    height: '100%',
    padding: '0 6px !important',
    display: 'flex',
    alignItems: 'center',
    borderRadius: '3px !important',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: theme.applyOpacityToHex(theme.palette.greyScale[0], 0.1),
    },
    '&:focus': {
      backgroundColor: theme.applyOpacityToHex(theme.palette.greyScale[0], 0.1),
    },
  },
}));


export default function RecurrenceSelect (props) {
  const classes = useStyles();
  const { scheduledTxn, onChange, className, inputClass } = props;

  const initialFrequency = scheduledTxn && frequencyAliasFromRecurrence(scheduledTxn.recurrence);
  const [recurrence, setRecurrence] = useState(initialFrequency);

  // frequency select menu population
  const { custom } = frequencyAliasTypes;
  const hasCustom = initialFrequency === custom;
  const menuItems = frequencyAliases.map((alias) => <MenuItem key={alias} value={alias}>{alias}</MenuItem>);
  // only show custom option if billScout defaulted to that
  if (hasCustom) menuItems.push(<MenuItem key={custom} value={custom}>{custom}</MenuItem>);

  const handleChange = (e) => {
    setRecurrence(e.target.value);
    if (onChange) {
      onChange(e.target.value === custom ?
        scheduledTxn.recurrence
        :
        recurrenceFromFrequencyAlias(e.target.value, scheduledTxn.dueOn))
    }
  };

  return (
    <Select
      value={recurrence}
      onChange={handleChange}
      inputProps={{
        id: 'found_recurring_frequency',
        className: classNames(classes.input, inputClass),
      }}
      IconComponent="div"
      disableUnderline
      className={classNames(classes.root, className)}
    >
      {menuItems}
    </Select>
  );
};

RecurrenceSelect.propTypes = {
  scheduledTxn: PropTypes.object,
  onChange: PropTypes.func,
  className: PropTypes.string,
  inputClass: PropTypes.string,
};
